import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import {
  listMyNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  NotificationItem,
} from "../../services/notifications.service";

export function Notifications() {
  const [items, setItems] = useState<NotificationItem[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await listMyNotifications({ take: 50 });
      setItems(res.items);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleReadAll = async () => {
    await markAllNotificationsAsRead();
    await load();
  };

  const handleReadOne = async (id: string) => {
    await markNotificationAsRead(id);
    await load();
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 900, mx: "auto", p: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight={700} color="#133859">
          Notificações
        </Typography>
        <Button variant="outlined" onClick={handleReadAll} disabled={loading}>
          Marcar tudo como lido
        </Button>
      </Stack>

      <Card>
        <CardContent>
          {loading && <Typography color="text.secondary">Carregando...</Typography>}

          {!loading && items.length === 0 && (
            <Typography color="text.secondary">Você não tem notificações.</Typography>
          )}

          <Stack spacing={1.5}>
            {items.map((n) => (
              <Box key={n.id}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                  <Typography fontWeight={n.wasRead ? 500 : 800}>
                    {n.title}
                  </Typography>
                  {!n.wasRead && <Chip size="small" color="warning" label="Novo" />}
                  <Typography variant="caption" color="text.secondary" sx={{ ml: "auto" }}>
                    {dayjs(n.createdAt).format("DD/MM/YYYY HH:mm")}
                  </Typography>
                </Stack>

                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  {n.body}
                </Typography>

                <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                  {!n.wasRead && (
                    <Button size="small" variant="outlined" onClick={() => handleReadOne(n.id)}>
                      Marcar como lida
                    </Button>
                  )}
                </Stack>

                <Divider sx={{ mt: 1.5 }} />
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
